<!-- carousel -->
<div class="carousel">
  <!--<ng-container *ngFor="let slide of slides; let i = index">
    <a [routerLink]="slide.link">
      <img
        *ngIf="i === currentSlide && slide.type === 'img'"
        [lazyLoad]="slide.src"
        [title]="slide.headline"
        class="slide"
        [@slideAnimation]="animationType"
      />
    </a>
  </ng-container>-->

  <!-- <ng-container *ngFor="let slide of slides; let i = index">
    <a [routerLink]="slide.link">
      <picture>
        <source *ngIf="i === currentSlide && slide.type === 'img'" [srcset]="slide.src" type="image/webp">
        <img *ngIf="i === currentSlide && slide.type === 'img'"
             [src]="slide.src.replace('.webp', '.png')"
        [title]="slide.headline"
        class="slide"
        [@slideAnimation]="animationType"
        />
      </picture>
    </a>
  </ng-container> -->

  <ng-container *ngFor="let slide of slides; let i = index">
    <a [routerLink]="slide.link">
    <img
      *ngIf="i === currentSlide && slide.type==='img'"
      [src]="slide.src"
      [title]="slide.headline"
      class="slide"
      [@slideAnimation]="animationType"  
      
    />
   </a>
  </ng-container>
  <!-- controls -->
  <button class="control prev" (click)="onPreviousClick()">
    <span class="arrow left"></span>
  </button>
  <button class="control next" (click)="onNextClick()">
    <span class="arrow right"></span>
  </button>
</div>
